import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { ResellerResponse } from '@utils/types/organization/reseller.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';

import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export const useGetResellers = () => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchResellers = async () => {
    const { resellers } = GET_URL_NEW({ offset, limit, sort, direction, q });
    const { data } = await Axios.get<ResellerResponse>(resellers);
    return data;
  };

  return useQuery<ResellerResponse, AxiosError<BaseError>>(
    ['resellers', offset, limit, q, sort, direction],
    fetchResellers,
    {
      enabled: !!TokenExtension.get()?.string,
      keepPreviousData: true
    }
  );
};
